import styled from '@emotion/styled'

import {
  ListItem,
  SuffixWrapper
} from '@vio/atlas/src/components/designSystem/ListItem'

export const Label = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const StyledListItem = styled(ListItem)`
  &.--as-button,
  &.--as-link {
    padding: 0;
    > div {
      align-items: center;
    }

    ${SuffixWrapper} {
      height: auto;
    }
  }
`
